import React from 'react';

const DoublingTimeCalculator = () => {
  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Doubling Time Calculator</h2>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <p>This calculator helps you determine the time it takes for something to double in size or value.</p>
      </div>
    </div>
  );
};

export default DoublingTimeCalculator;